import {
  requestFiles,
  cancelRequest,
  deleteFiles,
  downloadSupportFileConstants,
} from "../_redux-constants";
import { fuseSupportFilesService } from "../../_services";

// Request Support Files
function requestSupportFiles(queryParams, logRequestDates) {
  function fileRequestLoad() {
    return { type: requestFiles.FILE_REQUEST_LOADING };
  }
  function fileRequestSuccess(data) {
    return { type: requestFiles.FILE_REQUEST_SUCCESS, data };
  }
  function fileRequestFailure(error) {
    return { type: requestFiles.FILE_REQUEST_FAILURE, error };
  }

  return (dispatch) => {
    dispatch(fileRequestLoad());
    return fuseSupportFilesService
      .requestSupportFiles(queryParams, logRequestDates)
      .then(
        (data) => {
          dispatch(fileRequestSuccess(data));
        },
        (error) => {
          dispatch(fileRequestFailure(error?.toString()));
        }
      );
  };
}

// Cancel support files request
function cancelFileRequest(queryParams) {
  function cancelRequestLoad() {
    return { type: cancelRequest.CANCEL_REQUEST_LOADING };
  }
  function cancelRequestSuccess(data) {
    return { type: cancelRequest.CANCEL_REQUEST_SUCCESS, data };
  }
  function cancelRequestFailure(error) {
    return { type: cancelRequest.CANCEL_REQUEST_FAILURE, error };
  }

  return (dispatch) => {
    dispatch(cancelRequestLoad());
    return fuseSupportFilesService.cancelSupportFileRequest(queryParams).then(
      (data) => {
        dispatch(cancelRequestSuccess(data));
      },
      (error) => {
        dispatch(cancelRequestFailure(error?.toString()));
      }
    );
  };
}

// Delete files
function deleteSupportFiles(queryParams) {
  function deleteFilesLoad() {
    return { type: deleteFiles.DELETE_FILES_LOADING };
  }
  function deleteFilesSuccess(data) {
    return { type: deleteFiles.DELETE_FILES_SUCCESS, data };
  }
  function deleteFilesFailure(error) {
    return { type: deleteFiles.DELETE_FILES_FAILURE, error };
  }

  return (dispatch) => {
    dispatch(deleteFilesLoad());
    return fuseSupportFilesService.deleteSupportFiles(queryParams).then(
      (data) => {
        dispatch(deleteFilesSuccess(data));
      },
      (error) => {
        dispatch(deleteFilesFailure(error?.toString()));
      }
    );
  };
}

//download support file
function downloadSupportFile(queryParams) {
  function downloadSupportFileLoad() {
    return { type: downloadSupportFileConstants.DWNLD_SUPPORT_FILE_LOADING };
  }
  function downloadSupportFileSuccess(data) {
    return {
      type: downloadSupportFileConstants.DWNLD_SUPPORT_FILE_SUCCESS,
      data,
    };
  }
  function downloadSupportFileFailure(error) {
    return {
      type: downloadSupportFileConstants.DWNLD_SUPPORT_FILE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(downloadSupportFileLoad());
    return fuseSupportFilesService.downloadSupportFile(queryParams).then(
      (data) => {
        dispatch(downloadSupportFileSuccess(data));
      },
      (error) => {
        dispatch(downloadSupportFileFailure(error?.toString()));
      }
    );
  };
}

export const fuseSupportActions = {
  requestSupportFiles,
  cancelFileRequest,
  deleteSupportFiles,
  downloadSupportFile,
};
